import { Filter } from "@faire/retailer-visitor-shared/components/Filters/Filter";
import { FilterName } from "@faire/retailer-visitor-shared/components/Filters/FilterName";
import { useLoggedOutSuppliersPageIsPending } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageIsLoading";
import { useLoggedOutSuppliersPageTotalPrimaryResultsCount } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageTotalPrimaryResultsCount";
import { useLoggedOutSuppliersPageScrollOnFilterKeysChange } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/useScrollToBrandsSection";
import { getSpacing } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";

export const LoggedOutSuppliersPageFilterSidebar: React.FC<{
  scrollToBrandsSection: () => void;
}> = ({ scrollToBrandsSection }) => {
  const totalPrimaryResultsCount =
    useLoggedOutSuppliersPageTotalPrimaryResultsCount();
  const isPending = useLoggedOutSuppliersPageIsPending();

  useLoggedOutSuppliersPageScrollOnFilterKeysChange(scrollToBrandsSection);

  return (
    <div data-test-id="logged-out-suppliers-page-filter-sidebar">
      <StyledFilter
        name={FilterName.SUPPLIERS}
        resultsCount={totalPrimaryResultsCount ?? ""}
        headerSeparator
        isSticky
        isLoading={isPending}
      />
    </div>
  );
};

const StyledFilter = styled(Filter)`
  flex: 0 0 228px;
  margin-top: ${getSpacing("2x")};
  margin-right: ${getSpacing("4x")};
`;
